import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import Heading from "../../../Components/Heading/Heading";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  GetDropDownList,
  GetAppLifeCycDropDown,
  GetKRADetailsDashboardData,
  GetKRADetailsExcelData,
} from "../../../Helpers/API/APIEndPoints";
import moment from "moment";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { debounceSearchRender } from "mui-datatables";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import axios from "axios";
import fileDownload from "js-file-download";
import { Tooltip } from "antd";

const KRADashboard = () => {
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [LeaveRequestMasterData, setLeaveRequestMasterData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  // const [roleForData, setRoleForData] = useState(0);
  const { EmployeeId, RoleId } = getContext();
  const RoleIdArray = RoleId.split(",");

  const [employeeOptions, setEmployeeOptions] = useState<any>([]);
  const [statusDropdown, statusDropdownOptions] = useState<any>([]);

  const [filterFirst, setfilterrest] = useState(EmployeeId.toString());
  const [disabled, setDisabled] = useState(false);
  const [filterData, setFilterData] = useState(false);
  const [filterObj, setFilterObj] = useState<any>({
    employee: null,
    requestStatus: null,
  });
  const [isactivestring, setIsActiveString] = useState("active");
  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );
  const location = useLocation();
  const showCustomToolbar =
    location.state === "true" || location.state === "false";

  useEffect(() => {
    // debugger;

       //deepak gupta
    const clearUnwantedLocalStorage = () => {
      const keysToKeep = ["selectedStatusDropdown"];
      Object.keys(localStorage).forEach((key) => {
        if (!keysToKeep.includes(key)) {
          localStorage.removeItem(key);
        }
      });
    };

    clearUnwantedLocalStorage();   //deepak gupta
    getAllEmployees();
    handleSavedStatus();
    getApprisalCycle();
  }, []);

  useEffect(() => {
    getKraDashabordData();
  }, [
    start,
    sortColumn,
    sortDirection,
    searchText,
    filterData,
    isactivestring,
    statusDropdown,
    filterObj,
  ]);

  useEffect(() => {
    // debugger;
    showLoader();
    if (
      RoleIdArray.includes("3") ||
      (RoleIdArray.includes("4") && employeeOptions.length > 0)
    ) {
      const selectEmp = employeeOptions.find(
        (option) => option.value === Number(EmployeeId)
      );
      if (selectEmp) {
        setFilterObj((prev) => ({
          ...prev,
          employee: [selectEmp],
        }));
        setDisabled(false);
      }
    } else if (RoleIdArray.includes("8") && employeeOptions.length > 0) {
      const selectedEmp = employeeOptions.find(
        (option) => option.value === Number(EmployeeId)
      );
      if (selectedEmp) {
        setFilterObj((prev) => ({
          ...prev,
          employee: [selectedEmp],
        }));
        setDisabled(true);
      }
    }
    setFilterObj((prev) => ({ ...prev, requestStatus: statusDropdown[0] }));
    hideLoader();
  }, [RoleId, employeeOptions, EmployeeId, statusDropdown]);

  // console.log("RoleIdArray ", RoleIdArray);

  const handleSavedStatus = () => {
    const savedStatus = localStorage.getItem("selectedStatusDropdown");   //deepak gupta
    if (savedStatus) {
      setFilterObj((prev) => ({
        ...prev,
        requestStatus: JSON.parse(savedStatus),
      }));
      // setLocalAppId(savedStatus.value)
      // console.log("locally saved Status : ", savedStatus);

      // localStorage.removeItem("selectedStatusDropdown");
    }
  };

  // Get all Employees
  const getAllEmployees = async () => {
    showLoader();
    let postObject = {
      searchFor: "employee",
      searchValue: 1,
    };
    let x = {};
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let employees = [];
      await data.map((employee: any) => {
        let tempObj = {
          eid: employee.eid,
          value: employee.id,
          label: employee.name,
        };
        if (employee.id === Number(EmployeeId)) {
          x = {
            eid: employee.eid,
            value: employee.id,
            label: employee.name,
          };
        }
        employees.push(tempObj);
      });

      setEmployeeOptions(employees);
      hideLoader();
    }
  };

  const getApprisalCycle = async () => {
    showLoader();
    let postObject = {};
    let x = {};
    const { data } = await APICall(GetAppLifeCycDropDown, "POST", postObject);
    if (data != undefined || data != null) {
      let employees = [];
      await data.map((app: any) => {
        let tempObj = {
          value: app.value,
          label: app.label,
        };
        if (app.id === Number(EmployeeId)) {
          x = {
            value: app.value,
            label: app.label,
          };
        }
        employees.push(tempObj);
      });

      statusDropdownOptions(employees);
    }
    hideLoader();
  };

  // Get Dashboard data
  const getKraDashabordData = async () => {
    showLoader();
    const savedStatus = localStorage.getItem("selectedStatusDropdown");
    const parsedStatus = savedStatus ? JSON.parse(savedStatus) : null;
    // console.log(filterObj.requestStatus,'parse')
    let empIds = filterObj.employee
      ? filterObj.employee.map((e) => e.value).join(",")
      : "";

    let PassRoleId = null;
    if (RoleIdArray.includes("3")) {
      PassRoleId = 3; // Manager
    } else if (RoleIdArray.includes("4")) {
      PassRoleId = 4; // HR
    } else if (RoleIdArray.includes("8")) {
      PassRoleId = 8; //Operational Manager
    }

    let EmployeePass = "";
    if (empIds || empIds.split(",").length > 1) {
      EmployeePass = empIds;
    } else if (filterFirst) {
      EmployeePass = filterFirst;
    }

    let requestParams = {
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn,
      SortOrder: sortDirection,
      searchText: searchText,
      AppraisalCycleId:
        parsedStatus?.value || filterObj?.requestStatus?.value || 0,
      Emplpoyee: EmployeePass,
      EmpId: Number(EmployeeId), //Login Id
      RoleId: PassRoleId, //Login Role
      activeStatusId: isactivestring,
    };
    // console.log('obj=>',requestParams)
    const { data } = await APICall(
      GetKRADetailsDashboardData,
      "POST",
      requestParams
    );

    const kraMasterData = data?.map((ele: any) => {
      return {
        ...ele,
        fromDate: ele.fromDate
          ? moment(ele.fromDate).format("DD-MM-yyyy")
          : null,
        toDate: ele.toDate ? moment(ele.toDate).format("DD-MM-yyyy") : null,
      };
    });

    setCount(data[0]?.count);
    setLeaveRequestMasterData(kraMasterData);
    hideLoader();

    if (RoleId === 8) {
      const selectedEmp = employeeOptions.find(
        (option) => option.value === EmployeeId
      );
      if (selectedEmp) {
        setFilterObj(selectedEmp); // Sets the selected value
        // console.log("filterobj", filterObj);
      }
    }

    hideLoader();
  };

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "kraHeading",
      label: "KRA Heading",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "kraDescription",
      label: "KRA Description",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "appraisalCycleId",
      label: "Appraisal Cycle",
      options: {
        display: false,
      },
    },
    {
      name: "appCycle",
      label: "Appraisal Cycle",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "emplpoyee",
      label: "Employee",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "type",
      label: "Type",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "kraTypeId",
      label: "Type",
      options: {
        display: false,
      },
    },

    {
      name: "isActive",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },

    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          let kraHeading = tableMeta.tableData[tableMeta.rowIndex].kraHeading;
          let kraDescription =
            tableMeta.tableData[tableMeta.rowIndex].kraDescription;
          let appraisalCycleId =
            tableMeta.tableData[tableMeta.rowIndex].appraisalCycleId;
          let kraTypeId = tableMeta.tableData[tableMeta.rowIndex].kraTypeId;
          let employeeId = tableMeta.tableData[tableMeta.rowIndex].employeeId;
          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  className="action_icon"
                  onClick={(e) => {
                    e.preventDefault();
                    if (filterObj?.requestStatus) {
                      localStorage.setItem(
                        "selectedStatusDropdown",
                        JSON.stringify(filterObj.requestStatus)
                      );
                    }
                    navigate(`${env}/rating/kraRating/Edit`, {
                      state: {
                        id,
                        // kraHeading,
                        // kraDescription,
                        // appraisalCycleId,
                        // kraTypeId,
                        isDisable: true,
                      },
                    });
                  }}
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  const handleChange = (event: SelectChangeEvent) => {
    setIsActiveString(event.target.value);
  };

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    customSearchRender: debounceSearchRender(500),
    onChangeRowsPerPage: (num) => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={isactivestring}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };

  // const handleFilterChange = async (event, name) => {
  //   debugger;
  //   if (name === "employee" || name === "requestStatus") {
  //     setFilterObj((prev) => ({ ...prev, [name]: event || "" }));
  //   } else {
  //     setFilterObj((prev) => ({
  //       ...prev,
  //       [name]: event ? moment(event).format(moment.HTML5_FMT.DATE) : "",
  //     }));
  //   }
  // };

  const handleFilterChange = async (event, name) => {
    if (name === "employee") {
      setFilterObj((prev) => ({
        ...prev,
        [name]: event || null,
      }));

      // Reset filterFirst when no employee is selected
      if (!event || event.length === 0) {
        setfilterrest("");
      } else {
        setfilterrest(event.map((e) => e.value).join(","));
      }
    } else if (name === "requestStatus") {
      // console.log('even',event)

      setFilterObj((prev) => ({ ...prev, [name]: event || null }));
    } else {
      setFilterObj((prev) => ({
        ...prev,
        [name]: event ? moment(event).format(moment.HTML5_FMT.DATE) : "",
      }));
    }
  };

  const onClickFunction = async (action) => {
    if (action === "reset") {
      setFilterObj((prev) => {
        const updatedFilterObj = { ...prev };
        if (RoleIdArray.includes("3") || RoleIdArray.includes("4")) {
          updatedFilterObj.employee = null;
        }
        updatedFilterObj.requestStatus = null;
        return updatedFilterObj;
      });
      localStorage.removeItem("selectedStatusDropdown");
      setfilterrest("");
    }
    setFilterData(!filterData);
  };

  const ExportToExcel = () => {
    const savedStatus = localStorage.getItem("selectedStatusDropdown");
    const parsedStatus = savedStatus ? JSON.parse(savedStatus) : null;
    let empIds = filterObj.employee
      ? filterObj.employee.map((e) => e.value).join(",")
      : "";

    let PassRoleId = null;
    if (RoleIdArray.includes("3")) {
      PassRoleId = 3; // Manager
    } else if (RoleIdArray.includes("4")) {
      PassRoleId = 4; // HR
    } else if (RoleIdArray.includes("8")) {
      PassRoleId = 8; //Operational Manager
    }
    let EmployeePass = "";
    if (empIds || empIds.split(",").length > 1) {
      EmployeePass = empIds;
    } else if (filterFirst) {
      EmployeePass = filterFirst;
    }

    let requestParams = {
      start: start,
      pageSize: count,
      sortColumn: sortColumn,
      SortOrder: sortDirection,
      searchText: searchText,
      AppraisalCycleId:
        parsedStatus?.value || filterObj?.requestStatus?.value || 0,
      Emplpoyee: EmployeePass,
      EmpId: Number(EmployeeId), //Login Id
      RoleId: PassRoleId, //Login Role
      activeStatusId: isactivestring,
    };
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: GetKRADetailsExcelData,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
      })
      .then((response) => {
        fileDownload(
          response.data,
          `KRA-Rating-Details-` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
        console.log(error);
        alert(error);
      });
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"KRA Details"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex gap-2 justify-content-between">
              <div>
                <button
                  onClick={() =>
                    navigate(`${env}/rating/kraRating/Edit`, {
                      state: { id: 0, isDisable: false },
                    })
                  }
                  className="btn btn-update"
                >
                  Create
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={() => ExportToExcel()}
                  className="btn btn-export"
                >
                  Export to Excel
                </button>
                <a className="filterIcon" onClick={toggleFilter}>
                  <i className="fa fa-filter"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Employee</label>
                    <SelectForm
                      options={employeeOptions}
                      placeholder="Select"
                      value={filterObj.employee}
                      onChange={(event) =>
                        handleFilterChange(event, "employee")
                      }
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                      isClearable={true}
                      isDisabled={disabled}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Appraisal Life Cycle</label>
                    <SelectForm
                      options={statusDropdown}
                      placeholder="Select"
                      value={filterObj.requestStatus}
                      onChange={(event) =>
                        handleFilterChange(event, "requestStatus")
                      }
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                      isClearable={true}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex gap-2 justify-content-end">
                    <button
                      onClick={() => onClickFunction("reset")}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => onClickFunction("Submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={LeaveRequestMasterData}
              columns={gridColumns}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default KRADashboard;
